import { pushNotification } from "../../pushNotification";

export function aiCodeMetrics(args) {
  const { token, permissionCheckPath, downloadPath } = args || {};

  const handleHttpError = (status, isDownloading) => {
    if (status === 403) {
      pushNotification({
        title: "Not authorized",
        desc: "You do not have permission to download the source code.",
        success: false,
      });
    } else if (isDownloading) {
      pushNotification({
        title: "Download failed",
        desc: "Something went wrong while downloading the source code. Please try again.",
        success: false,
      });
    } else {
      pushNotification({
        title: "Error",
        desc: "Something went wrong while checking permissions. Please try again.",
        success: false,
      });
    }
  };

  return {
    showAiCodeMetricsRegenerateTokenModal: false,
    showAiCodeMetricsDownloadSourceModal: false,

    copyToken() {
      navigator.clipboard.writeText(token).then(() => {
        pushNotification({
          title: "Token copied to clipboard",
          desc: "Paste it wherever you would like.",
        });
      });
    },

    async checkPermissionAndOpenModal() {
      try {
        const response = await fetch(permissionCheckPath, {
          headers: { Accept: "application/json" },
        });
        if (response.ok) {
          this.showAiCodeMetricsDownloadSourceModal = true;
        } else {
          handleHttpError(response.status, false);
        }
      } catch {
        handleHttpError(null, false);
      }
    },

    async downloadSource() {
      try {
        const response = await fetch(downloadPath);
        if (!response.ok) {
          this.showAiCodeMetricsDownloadSourceModal = false;
          handleHttpError(response.status, true);
          return;
        }

        const blob = await response.blob();
        const disposition = response.headers.get("Content-Disposition") || "";
        const filenameMatch = disposition.match(/filename=(.+)/);
        const filename = filenameMatch
          ? filenameMatch[1]
          : "ai-code-metrics-source.tar.gz";
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
        this.showAiCodeMetricsDownloadSourceModal = false;
      } catch (e) {
        this.showAiCodeMetricsDownloadSourceModal = false;
        handleHttpError(null, true);
      }
    },
  };
}
